// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const calyrex: PokeData = {
  "id": 898,
  "name": "calyrex",
  "height": 11,
  "weight": 77,
  "base_experience": 250,
  "types": [
    PokeType.PSYCHIC,
    PokeType.GRASS
  ],
  "api_moves": [
    "pound",
    "mega-drain",
    "leech-seed",
    "growth",
    "solar-beam",
    "confusion",
    "psychic",
    "giga-drain",
    "future-sight",
    "helping-hand",
    "aromatherapy",
    "energy-ball",
    "psyshock",
    "heal-pulse",
    "grassy-terrain",
    "psychic-terrain",
    "life-dew"
  ],
  "moves": [
    "solar-beam",
    "psychic",
    "future-sight",
    "aromatherapy",
    "energy-ball",
    "grassy-terrain",
    "psychic-terrain",
    "life-dew",
    "reflect",
    "prismatic-cage",
    "flower-rush",
    "vine-whip",
    "synchronize"
  ],
  "evolution_chain": {
    "id": 476,
    "item": null,
    "species": [
      {
        "name": "calyrex",
        "order": 898,
        "types": [
          PokeType.PSYCHIC,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 144,
    "speed": 128,
    "ability_power": 128
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
